<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';

	interface Props {
		icon: IconName;
		length: number;
		filledLength: number;
		colorForFilled?: string;
		colorForUnFilled?: string;
	}

	const {
		icon,
		length,
		filledLength,
		colorForFilled = '',
		colorForUnFilled = 'text-neutral',
	}: Props = $props();
</script>

<div class="flex row w-max">
	{@render repeatIcons(filledLength, colorForFilled)}
	{@render repeatIcons(length - filledLength, colorForUnFilled)}
</div>

{#snippet repeatIcons(amount: number, classes: string)}
	<RepeatIcons {icon} {amount} class={classes} style="currency" tag="span" iconTag="span" />
{/snippet}
